function checkCookie(cookieName) {
  // Split the cookie string into an array of individual cookies
  let cookies = document.cookie.split(';');

  // Loop through each cookie to check if the specified cookie exists
  for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      // Check if the cookie starts with the provided cookieName
      if (cookie.startsWith(cookieName + '=')) {
          // Cookie found
          return true;
      }
  }
  // Cookie not found
  return false;
}

let cookieExists = checkCookie('NudgeAnimation');
if (cookieExists) {
  document.querySelector(`#product-grid .grid__item.ItemToBeNudged`).classList.add(`nudgeDisabled`);
} else {
  document.cookie = "NudgeAnimation=true; path=/";
}
